import {MixedMercantile} from "api/quote";
import {Box} from "components/Box";
import {GridContainer} from "components/Grid";
import Field from "../../Field";
import FormTitle from "pages/RateQuoteBind/components/FormTitle";
import DebitsAndCreditsSection from "../shared/DebitsAndCredits";
import {usePermissions} from "hooks/auth";
import {Permissions} from "api/auth";

function MixedMercantileCoverageForm({
  mixedMercantile,
}: {
  mixedMercantile: MixedMercantile;
}) {
  const permissions = usePermissions();

  return (
    <Box mb={100}>
      <GridContainer rowGap={24} columnGap={16}>
        <Field.CheckBox
          label="Terrorism Coverage"
          object={mixedMercantile}
          field={"terrorism_coverage_flag"}
          wrapperProps={{
            grow: 12,
          }}
        />
        <Field.CheckBox
          label="Equipment Breakdown"
          object={mixedMercantile}
          field={"equipment_breakdown"}
          wrapperProps={{
            grow: 12,
          }}
        />
        <Field.CheckBox
          label="Property Enhancement"
          object={mixedMercantile}
          field={"property_enhancement"}
          wrapperProps={{
            grow: 12,
          }}
        />
        {permissions.includes(Permissions.BACKEND_QUOTING) && (
          <Field.CheckBox
            label="Debits/Credits - Field Only Available for AE Internal - UW"
            object={mixedMercantile}
            field={"credit_and_debits_flag"}
            wrapperProps={{
              grow: 12,
              style: {
                backgroundColor: "rgba(255, 255, 125)",
                borderTopLeftRadius: "6px",
                borderTopRightRadius: "6px",
                borderBottomLeftRadius: !mixedMercantile.credit_and_debits_flag
                  ? "6px"
                  : "0px",
                borderBottomRightRadius: !mixedMercantile.credit_and_debits_flag
                  ? "6px"
                  : "0px",
              },
            }}
          />
        )}
        {mixedMercantile.credit_and_debits_flag &&
          permissions.includes(Permissions.BACKEND_QUOTING) &&
          !mixedMercantile.debits_and_credits.length && (
            <>
              <Field.TextInput
                object={mixedMercantile!}
                field={"gl_credit_and_debits_percentage"}
                label="Schedule Rating Percentage"
                prefix="%"
                type="number"
                wrapperProps={{
                  growXXS: 12,
                  growMD: 6,
                  style: {
                    backgroundColor: "rgba(255, 255, 125)",
                    borderBottomLeftRadius: "6px",
                  },
                }}
              />
              <Field.TextInput
                object={mixedMercantile!}
                field={"gl_credit_and_debits_reason"}
                label="Schedule Rating Reason"
                wrapperProps={{
                  growXXS: 12,
                  growMD: 6,
                  style: {
                    backgroundColor: "rgba(255, 255, 125)",
                    borderBottomRightRadius: "6px",
                  },
                }}
              />
              <Field.TextInput
                object={mixedMercantile!}
                field={"pr_credit_and_debits_percentage"}
                label="IRPM Percentage"
                prefix="%"
                type="number"
                wrapperProps={{
                  growXXS: 12,
                  growMD: 6,
                  style: {
                    backgroundColor: "rgba(255, 255, 125)",
                    borderBottomLeftRadius: "6px",
                  },
                }}
              />
              <Field.TextInput
                object={mixedMercantile!}
                field={"pr_credit_and_debits_reason"}
                label="IRPM Reason"
                wrapperProps={{
                  growXXS: 12,
                  growMD: 6,
                  style: {
                    backgroundColor: "rgba(255, 255, 125)",
                    borderBottomRightRadius: "6px",
                  },
                }}
              />
            </>
          )}
      </GridContainer>
      {mixedMercantile.credit_and_debits_flag &&
      permissions.includes(Permissions.BACKEND_QUOTING) &&
      mixedMercantile.debits_and_credits.length ? (
        <div>
          <FormTitle.Header2>Debits and Credits</FormTitle.Header2>
          <DebitsAndCreditsSection
            debitsAndCredits={mixedMercantile.debits_and_credits}
          />
        </div>
      ) : null}
    </Box>
  );
}

export default MixedMercantileCoverageForm;
